import { render } from "./MenuSide.vue?vue&type=template&id=d835681c&scoped=true"
import script from "./MenuSide.vue?vue&type=script&lang=js"
export * from "./MenuSide.vue?vue&type=script&lang=js"

import "./MenuSide.vue?vue&type=style&index=0&id=d835681c&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d835681c"]])

export default __exports__